// IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: живой поиск и чипсы поиска)
// Живой поиск полосы чипсов таблицы: пока текст набирается (до Enter), таблица ведёт себя как при чипсе поиска с «Show rows without matches» —
// строки не прячутся, найденное подсвечено, счётчик считается. Набранный текст живёт в ВИРТУАЛЬНОМ чипсе грида (liveChip, _live / _isVirtual):
// он не попадает в запись виджета (doc.viewParams.<грид>.CHIPS) и в стол — AttrGrid читает его только в местах поиска (CHIPS_view), сеттер CHIPS
// его отфильтровывает. Enter оформляет текст в обычный чипс (AttrChips.addChip). Выключатели: fe.ux.gridLiveSearch (дефолт вкл; false — ввод
// ничего не делает до Enter), fe.ux.gridLiveSearchDebounceMs (пауза ввода, дефолт 250 мс).

export const LIVE_DEBOUNCE_DEFAULT = 250
export const LIVE_DEBOUNCE_MAX = 2000

// текст живого поиска: служебные запросы (выражение «= row.x», отбор по стилям «style:», переход к родителю «>> ») живьём не ищутся — это команды, их
// оформляет только Enter
export function liveSearch_text(raw) {
    const t = String(raw ?? '').trim()
    if (!t) return ''
    if (t.startsWith('=') || t.startsWith('>>') || t.toLowerCase().startsWith('style:')) return ''
    return t
}

// пауза перед поиском: очистка — сразу; иначе настройка базы (число, 0..2000), мусор — умолчание
export function liveSearch_delay(setting, text) {
    if (!text) return 0
    const n = Number(setting)
    if (setting === null || setting === undefined || setting === '' || !Number.isFinite(n) || n < 0) return LIVE_DEBOUNCE_DEFAULT
    return Math.min(Math.round(n), LIVE_DEBOUNCE_MAX)
}

export function liveChip_new() {
    return { segment: 'CHIP-Search', title: '', meta: { use: true, pi: 'pi-search' }, showAllLines: true, _live: true, _isVirtual: true, matchCount: null, matchIndex: 0 }
}

// новый текст в живой чипс; true — текст сменился (нужен проход отбора). Решения лестницы поиска, привязанные к прежнему тексту, снимаются
export function liveChip_set(chip, text) {
    const t = String(text ?? '')
    if (!chip || chip.title === t) return false
    chip.title = t
    for (const k of ['_fuzzy', '_fuzzyFor', '_phrase', '_phraseFor', '_alt', '_altFor', '_extra', '_extraFor', '_extraFrom', '_layoutConvFrom', '_laneMatch']) delete chip[k]
    chip.matchCount = null
    chip.matchIndex = 0
    return true
}

export const chip_isLive = (c) => !!(c && c._live)

// чипсы для поиска: сохранённые + живой (если в нём есть текст); сохранённый массив без живого — тот же объект (ничего не копируется)
export function chips_withLive(stored, live) {
    const list = Array.isArray(stored) ? stored : []
    return (live && live._live && String(live.title || '').trim()) ? list.concat([live]) : list
}

// в запись / стол живой чипс не пишется никогда
export function chips_dropLive(list) {
    if (!Array.isArray(list) || !list.some(chip_isLive)) return list
    return list.filter(c => !chip_isLive(c))
}
